<div class="landing">
  <app-navbar></app-navbar>
  <app-mainpage></app-mainpage>
  <app-footer></app-footer>
</div>